module.exports = __webpack_public_path__ + "static/media/Media Activity.8123512c.svg";